import { Content } from "../components/Content/Content";
import { Socials } from "../components/Socials/Socials";
import { HomePageWrapper } from "../components/home/home-page.styled";

export const HomePage = () => {
  return (
    <HomePageWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
      className="HomePageWrapper"
    >
      <Content />
      <Socials />
    </HomePageWrapper>
  );
};
